import React, { useMemo, useState } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import DataTable from "react-data-table-component";
import { LuArrowUpDown } from "react-icons/lu";
import "../assets/css/styles.css";
import Popover from "./popover";
import { useEffect } from "react";
import axiosInstance from "../services/axiosInstance";
import EditDentistDetailPopup from "../Popup/editDentistDetailPopup";
import DeleteDentistPopup from "../Popup/deleteDentistPopup";

const SortIcon = ({ sortDirection }) => {
  if (sortDirection === "asc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  if (sortDirection === "desc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  return (
    <LuArrowUpDown
      className="ml-1 !w-4 !h-5"
      style={{ color: "#EFEFEF", opacity: "1" }}
    />
  );
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#376EA4",
      color: "#FAFDFF",
      fontSize: "16px",
      fontFamily: "InterBold",
      padding: "15px",
      opacity: "1",
      textAlign: "center",
    },
    hoverStyle: {
      color: "#FAFDFF",
      opacity: "1",
    },
  },
  rows: {
    style: {
      fontSize: "16px",
      color: "#828282",
      padding: "6px",
      backgroundColor: "rgba(252, 252, 252, 0.5) !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8) !important",
      borderTop: "1px solid rgba(239, 239, 239, 0.8) !important",
      "&:nth-child(2n)": {
        backgroundColor: "rgba(249, 249, 249, 0.6) !important",
      },
      textAlign: "center",
    },
    highlightOnHoverStyle: {
      fontSize: "16px",
      color: "#202020",
      padding: "6px",
      backgroundColor: "#F4F9FF !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8) !important",
      borderTop: "1px solid rgba(239, 239, 239, 0.8) !important",
    },
  },
  table: {
    style: {
      display: "block",
      maxHeight: "calc(100vh - 330px)",
      height: "fit-content",
      overflowY: "auto",
      borderCollapse: "separate",
      borderSpacing: 0,
      "@media screen and (min-width: 1600px)": {
        maxHeight: "calc(100vh - 340px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 760px) and (max-width: 1250px)": {
        maxHeight: "calc(100vh - 330px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxHeight: "calc(100vh - 360px)",
        overflowX: "hidden",
      },
    },
  },
};

const DentistTable = ({
  searchItem,
  getDentistList,
  dentistList,
  setDentistList,
}) => {
  const [openEditDetailPopup, setOpenEditDetailPopup] = useState(false);
  const HandleRemovePopUp = () => setOpenEditDetailPopup(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const HandleDeleteRemovePopUp = () => setDeletePopup(false);
  const [selectedDentist, setSelectedDentist] = useState(null);

  useEffect(() => {
    getDentistList();
  }, []);

  const memoizedDentistList = useMemo(() => dentistList, [dentistList]);

  const filteredOrders = React.useMemo(() => {
    const dentistData = [...memoizedDentistList];
    return dentistData.filter(
      (user) =>
        user.dentistCode.toLowerCase().includes(searchItem.toLowerCase()) ||
        user.dentistDisplayName
          .toLowerCase()
          .includes(searchItem.toLowerCase()) ||
        user.dentistName.toLowerCase().includes(searchItem.toLowerCase()) ||
        user.geoCode.toLowerCase().includes(searchItem.toLowerCase()) ||
        user.pP_Notes.toLowerCase().includes(searchItem.toLowerCase()) ||
        user.practiceName.toLowerCase().includes(searchItem.toLowerCase())
    );
  }, [memoizedDentistList, searchItem]);

  const columns = [
    {
      name: "Dentist Code",
      selector: (row) => row?.dentistCode,
      sortable: true,
      sortFunction: (a, b) => a.dentistCode.localeCompare(b.dentistCode),
    },
    {
      name: "Practice Name",
      selector: (row) => row?.practiceName,
      sortable: true,
      sortFunction: (a, b) => a.practiceName.localeCompare(b.practiceName),
    },
    {
      name: "Dentist Display Name",
      selector: (row) => row?.dentistDisplayName,
      sortable: true,
      sortFunction: (a, b) =>
        a.dentistDisplayName.localeCompare(b.dentistDisplayName),
    },
    {
      name: "PP Notes",
      selector: (row) => row?.pP_Notes,
      sortable: true,
      sortFunction: (a, b) => a.pP_Notes.localeCompare(b.pP_Notes),
    },
    {
      name: "Geo Code",
      selector: (row) => row?.geoCode,
      sortable: true,
      sortFunction: (a, b) => a.geoCode.localeCompare(b.geoCode),
    },
    {
      name: "Vorschau",
      className: "w-40 px-5",
      selector: (row) => row.actions,
      sortable: false,
      cell: (row) => (
        <div className="flex items-center gap-4">
          <Popover
            trigger="hover"
            content={
              <p
                className="absolute -right-0 -top-7 max-w-fit px-2 py-1 text-lg bg-blue rounded text-blue-400 w-auto whitespace-nowrap after:content-[' '] after:-bottom-2 after:left-0 after:right-0 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] font-interRegular"
                style={{}}
              >
                Bearbeiten
              </p>
            }
          >
            <button
              onClick={() => {
                setOpenEditDetailPopup(true);
                setSelectedDentist(row);
              }}
              className="rounded-lg p-2 my-1 border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)] transition-all ease-in focus:border-blue-600"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/edit_square.svg" width="20px" height="20px" />
            </button>
          </Popover>
          <Popover
            trigger="hover"
            content={
              <p
                className="absolute -right-2 -top-7 max-w-fit text-blue-400 px-2 py-1 text-lg bg-red rounded w-auto whitespace-nowrap after:content-[' '] after:-bottom-2 after:left-0 after:right-0 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-red shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] font-interRegular"
                style={{}}
              >
                Delete
              </p>
            }
          >
            <button
              onClick={() => {
                setDeletePopup(true);
                setSelectedDentist(row);
              }}
              className="rounded-lg p-[10px] my-1 border border-transparent shadow-[0_0_4px_rgba(253,37,30,0.3)] hover:border-[rgba(238,18,10,0.5)] transition-all ease-in focus:border-[rgba(238,18,10,0.5)]"
              style={{
                backgroundColor: "rgba(238, 18, 10, 0.05)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <RiDeleteBin6Line className="text-[#EE120A] " />
            </button>
          </Popover>
        </div>
      ),
      ignoreRowClick: true,
      // allowoverflow: true,
      // button: true,
    },
  ];

  return (
    <div>
      <DataTable
        noDataComponent={
          <div className="py-4 text-gray-500">
            Es sind keine Datensätze zum Anzeigen vorhanden
          </div>
        }
        className=" mt-6 !rounded-xl shadow-[0_0_8px_rgba(44,99,152,0.2)] font-interRegular"
        scrollable
        scrollHeight="590px"
        fixedHeader
        columns={columns}
        data={filteredOrders || []}
        pagination={false}
        customStyles={customStyles}
        sortIcon={<SortIcon />}
        highlightOnHover
      />

      <EditDentistDetailPopup
        getDentistList={getDentistList}
        dentistList={dentistList}
        dentist={selectedDentist}
        setDentist={setSelectedDentist}
        openPopUp={openEditDetailPopup}
        closePopUp={HandleRemovePopUp}
      />
      <DeleteDentistPopup
        dentist={selectedDentist}
        dentistList={dentistList}
        setDentistList={setDentistList}
        getDentistList={getDentistList}
        openPopUp={deletePopup}
        closePopUp={HandleDeleteRemovePopUp}
      />
    </div>
  );
};

export default DentistTable;
